<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>

<script>
  export default {name: 'app'}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:200,200i,300,300i,400,400i,600,600i,700,700i,900,900i');

  @import './styles/theme.scss';
  
  #app {
    /* Set the site's font and default color */
    font-family: 'Source Sans Pro', sans-serif;
    color: #333;

    .webchat.ember-application {
      .h-header {
        color: $tingg-white;
        background: $tingg-pink;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue